import React, { useState } from 'react'
import FlashNotification from '../shared/flashNotification'
import OrderCreationForm from './OrderCreationForm'

interface Props {
  currency: { code: string }
  newOrderAvailable: boolean
}

const OrderModal = ({ currency, newOrderAvailable }: Props) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [flashOpen, setFlashOpen] = useState(false)
  const [flashType, setFlashType] = useState('')
  const [flashMessage, setFlashMessage] = useState('')

  const showError = (message: string) => {
    setFlashType('danger')
    setFlashMessage(message)
    setFlashOpen(true)
  }

  return (
    <>
      {newOrderAvailable && (
        <button className='btn btn-primary' onClick={() => setModalOpen(true)} disabled={modalOpen}>
          + New Order
        </button>
      )}
      {modalOpen && (
        <OrderCreationForm
          currency={currency}
          onClose={() => setModalOpen(false)}
          onError={showError}
        />
      )}
      {flashOpen && (
        <FlashNotification
          type={flashType}
          message={flashMessage}
          onClose={() => setFlashOpen(false)}
        />
      )}
    </>
  )
}

export default OrderModal
